import React, { createContext, useContext, useState, useEffect } from 'react';

const CartContext = createContext();

export const CartProvider = ({ children }) => {
  const [cartItems, setCartItems] = useState(() => {
    try {
      const localData = localStorage.getItem('laliel_cart');
      return localData ? JSON.parse(localData) : [];
    } catch (e) {
      return [];
    }
  });

  const [isCartOpen, setIsCartOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem('laliel_cart', JSON.stringify(cartItems));
  }, [cartItems]);

  // 🟢 DÜZƏLDİLMİŞ addToCart FUNKSİYASI (2 ƏDƏD ARTMA SƏHVİNİ HƏLL EDİR)
  const addToCart = (productToAdd) => {
    setCartItems((prevItems) => {
      let validId = Number(productToAdd.id || productToAdd.productId || productToAdd._id);

      if (!validId || isNaN(validId)) {
        validId = Math.floor(1000 + Math.random() * 9000);
      }

      const selectedSize = productToAdd.size || 'STD';

      // Səbətdə bu məhsulun olub-olmadığını yoxlayırıq:
      const existingItemIndex = prevItems.findIndex(
        (item) => Number(item.id || item.productId) === validId && item.size === selectedSize
      );

      // Əlavə ediləcək miqdar (mütləq 1 verilməlidir, əgər xüsusi miqdar gəlmirsə)
      const amountToAdd = Number(productToAdd.quantity) > 0 ? Number(productToAdd.quantity) : 1;

      if (existingItemIndex > -1) {
        // Mövcuddursa, sadəcə miqdarını tam olaraq üzərinə gəlirik
        return prevItems.map((item, index) => {
          if (index === existingItemIndex) {
            return {
              ...item,
              quantity: item.quantity + amountToAdd
            };
          }
          return item;
        });
      }

      // Yeni məhsuldursa, səbətə 1 ədəd kimi əlavə edirik
      const newItem = {
        ...productToAdd,
        id: validId,
        productId: validId,
        quantity: amountToAdd,
        size: selectedSize,
        color: productToAdd.color || 'Standard'
      };

      return [...prevItems, newItem];
    });
  };

  const removeFromCart = (id) => {
    const targetId = Number(id);
    setCartItems((prev) => prev.filter((item) => Number(item.id || item.productId) !== targetId));
  };

  const updateQuantity = (id, newQty) => {
    if (newQty < 1) {
      removeFromCart(id);
      return;
    }
    const targetId = Number(id);
    setCartItems((prev) =>
      prev.map((item) =>
        Number(item.id || item.productId) === targetId ? { ...item, quantity: newQty } : item
      )
    );
  };

  const getTotalItems = () => {
    return cartItems.reduce((total, item) => total + Number(item.quantity || 1), 0);
  };

  const getTotalPrice = () => {
    return cartItems.reduce((total, item) => total + Number(item.price || 0) * Number(item.quantity || 1), 0);
  };

  const clearCart = () => {
    setCartItems([]);
    localStorage.removeItem('laliel_cart');
  };

  return (
    <CartContext.Provider
      value={{
        cartItems,
        isCartOpen,
        setIsCartOpen,
        addToCart,
        removeFromCart,
        updateQuantity,
        getTotalItems,
        getTotalPrice,
        clearCart
      }}
    >
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);